'use client';

import { cn, getColorway } from '@/utils/styles';

import DesktopCardsVerticalScrollItem from './covariants/DesktopCardsVerticalScrollItem';
import MobileCardsVerticalScrollItem from './covariants/MobileCardsVerticalScrollItem';
import { CardsVerticalScrollItemProps } from './types';
import { useState } from 'react';
import { trackExpandableCardItemToggled } from '../analytics/eventHandlerTracking';
import { useExpandableCardsItemToggleTracking } from '../analytics/hooks';

const CardsVerticalScrollItem = ({ backgroundColor, bulletStyle, ...props }: CardsVerticalScrollItemProps) => {
  const cardsExpandTracking = useExpandableCardsItemToggleTracking({
    label: 'Cards Vertical Scroll Module',
  });

  const [isExpanded, setIsExpanded] = useState(true);

  const internalClassNames = {
    wrapper: cn(
      'min-h-38 md:min-h-25 rounded-lg relative transition-all shadow-black/25 shadow-[0_-10px_20px]',
      { '-mt-21 sm:-mt-6 md:-mt-8': props.index > 0, 'sm:rounded-bl-none': !isExpanded },
      getColorway(backgroundColor),
    ),
  };

  const handleExpand = () => {
    const newExpandedState = !isExpanded;
    setIsExpanded(newExpandedState);

    cardsExpandTracking();
    trackExpandableCardItemToggled({
      action: newExpandedState ? 'open' : 'close',
    });
  };

  return (
    <div className={internalClassNames.wrapper} style={{ zIndex: 10 + props.index }}>
      <DesktopCardsVerticalScrollItem {...props} bulletStyle={bulletStyle} isExpanded={isExpanded} onExpand={handleExpand} />
      <MobileCardsVerticalScrollItem {...props} bulletStyle={bulletStyle} isExpanded={isExpanded} onExpand={handleExpand} />
    </div>
  );
};

export default CardsVerticalScrollItem;
